<template>
  <v-card class="elevation-4" :color="color" dark max-width="500px">
    <v-card-text>
      <v-flex xs12 class="text-center">
        {{$t(loadingText)}}...
      </v-flex>
      <!-- <v-progress-linear indeterminate color="white" class="mb-0" ></v-progress-linear> -->
      <v-flex xs12 class="mt-2 text-center">
        <v-progress-circular :size="70" :width="7" color="white" indeterminate></v-progress-circular>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'CardLoading',
    props: {
      loadingText: {
        type: String,
        default: () => 'loading'
      },
      color: {
        type: String,
        default: () => 'primary'
      }
    },
  }
</script>

<style scoped>

</style>